export default Object.freeze({
  AdminProvider: 'AdminProvider',
  AdminProviderCenter: 'AdminProvider - Centro',
  Provider: 'Provider',
  Administrador: 'Administrador',
  AdminSAEE: 'AdminSAEE',
  AdminIL: 'AdminIL',
  ProviderCPA: 'Proveedor CPA',
  InterventorCentro: 'Interventor - Centro',
  DirectorCentro: 'Director Centro',
  AsistenciaTecnica: 'Asistencia Técnica',
  CentroIsla: 'Centro-Isla',
  AsistenteProveedor: 'Asistente Proveedor',
  AdminProInfo: 'AdminProInfo',
  Especialista: 'Especialista',
  EspecialistaDEPR: 'Especialista',
  Proponente: 'Proponente',
  UMESRAdmin: 'UMESR Admin',
  AuxiliarAdministrativo: 'Auxiliar Administrativo',
  Centro: 'Centro',
  ProviderPagoDirecto: 'Provider-Pago Directo',
  BecaAsistencia: 'Beca Asistencia',
  DirectorAuxiliar: 'Director Auxiliar',
});
